import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { IconAndTextWrapper } from './IconAndText.styles';
import { Icon } from '../Icon';
/**
 * Description for IconAndText
 */

export var IconAndText = React.forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
      _ref$toRight = _ref.toRight,
      toRight = _ref$toRight === void 0 ? false : _ref$toRight,
      children = _ref.children,
      iconProps = _ref.iconProps,
      props = _objectWithoutProperties(_ref, ["icon", "toRight", "children", "iconProps"]);

  return /*#__PURE__*/React.createElement(IconAndTextWrapper, Object.assign({
    toRight: toRight
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(Icon, Object.assign({
    icon: icon
  }, iconProps)), /*#__PURE__*/React.createElement("span", null, children));
});